import { render, staticRenderFns } from "./PopUpMessage.vue?vue&type=template&id=14f9c548"
import script from "./PopUpMessage.vue?vue&type=script&lang=js"
export * from "./PopUpMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports